import axios from "axios";

export default class QuizApi {
    static getBaseUrl() {

        //return "https://dun.vydeo.xyz/quiz";
        return "https://dun.vydeo.xyz/iter3/quiz";
         //return "http://localhost:80/quiz";

    }

    static async getQuiz(turnstile_token) {
        if (!localStorage.getItem("token")) {
            return
        }
        try {
            return axios.get(`${QuizApi.getBaseUrl()}/start?token=` +turnstile_token , {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    captcha: turnstile_token,
                },
            });
        } catch (error) {
            throw new Error(error.response?.data?.message || "Network error while fetching quiz");
        }
    }

    static async submitQuiz(answers, quiz_id) {
        if (!localStorage.getItem("token")) {
            return
        }

        try {
            console.log(quiz_id)
            const response = await axios.post(
                `${QuizApi.getBaseUrl()}/submit`,
                { "answers": answers, "quiz_id": quiz_id },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,

                    }
                }
            );
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || "Network error while submitting quiz");
        }
    }


    static async getSelections(index) {
        if (!localStorage.getItem("token")) {
            return
        }
        try {
            return axios.get(`${QuizApi.getBaseUrl()}/get_selections?question_id=${index}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            });
        } catch (error) {
            throw new Error(error.response?.data?.message || "Network error while fetching selections");
        }

    }
}